<template>
  <modal title="Inventory Edit" height="320px">
    <template #top>
      <div class="h5 mb-0">Edit {{ editHeader }}</div>
    </template>
    <template #footer>
      <b-button variant="outline-secondary" class="px-3 mr-2" @click="$emit('submit', false)" size="sm">Cancel
      </b-button>
      <b-button variant="outline-primary" class="px-3" @click="update" size="sm">Update</b-button>
    </template>

    <div class="mx-2">
      <b-alert show class="mb-3" v-if="multi">Changes will apply to all <b>{{ value.length }}</b> selected records.
      </b-alert>

      <modal-row label="PO">
        <form-select-remote-search v-model="edit.fkstockpo" key-text="description" key-value="id"
                                   url="/api/po?limit=100"
                                   search-url="/api/po?q="/>
      </modal-row>

      <modal-row label="Notes / Instructions" v-if="!multi && can('items.inventory.notes.read')">
        <b-form-textarea v-model="edit.notes" rows="6" size="sm"/>
      </modal-row>
      <modal-row label="Testing">
        <form-select v-model="edit.testing" :options="$store.state.settings.defaults.inventory_testing" ize="sm"/>
      </modal-row>
      <modal-row label="Condition">
        <form-select v-model="edit.item_condition" :options="$store.state.settings.defaults.inventory_condition"/>
      </modal-row>

      <modal-row v-if="item.user1" :label="item.user1">
        <b-form-input v-model="edit.user1" size="sm"/>
      </modal-row>
      <modal-row v-if="item.user2" :label="item.user2">
        <b-form-input v-model="edit.user2" size="sm"/>
      </modal-row>

      <modal-row label="Serial No" v-if="!multi">
        <b-form-input v-model="edit.serialno" size="sm" @keypress.enter="update"/>
      </modal-row>
    </div>

  </modal>
</template>

<script>
export default {
  name: "item-inventory-edit",

  props: {
    item: {
      type: Object,
      required: true
    },
    value: {
      type: Array,
      required: true
    },
  },

  computed: {
    editHeader() {
      return this.multi ? this.value.length + ' records' : this.value[0].gli
    },
    multi() {
      return this.value.length > 1
    }
  },

  mounted() {
    if (!this.value.length)
      this.$emit('submit', false)

    if (!this.multi) {
      this.edit = {
        fkstockpo: this.value[0].fkstockpo,
        testing: this.value[0].testing,
        item_condition: this.value[0].item_condition,
        user1: this.value[0].user1,
        user2: this.value[0].user2,
        serialno: this.value[0].serialno
      }
      if (this.can('items.inventory.notes.read'))
        this.$set(this.edit, 'notes', this.value[0].notes)
    } else {
      this.edit = {}
    }
  },

  data() {
    return {
      edit: {}
    }
  }
  ,
  methods: {
    async update() {
      let data = Object.fromEntries(Object.entries(this.edit).filter(([_, v]) => v != null));
      for (let i = 0; i < this.value.length; i++) {
        await this.asyncAction(this.value[i]._links.self_url.href, 'PUT', {
          data
        })
        this.toast('Record ' + this.value[i].gli + ' updated.')
      }
      this.$emit('submit', true)
    }
  }
}
</script>

<style scoped>

</style>